import { render, staticRenderFns } from "./DesenvolvidoPor.vue?vue&type=template&id=e10ebf3e&scoped=true"
import script from "./DesenvolvidoPor.vue?vue&type=script&lang=js"
export * from "./DesenvolvidoPor.vue?vue&type=script&lang=js"
import style0 from "./DesenvolvidoPor.vue?vue&type=style&index=0&id=e10ebf3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10ebf3e",
  null
  
)

export default component.exports